import { PropsWithChildren } from 'react';
import { Button } from '@/Components/UI/Button';

type StepperItemProps = PropsWithChildren<{
    title?: string;
    isActive?: boolean;
    onClick?: () => void;
}>

export const StepperItem = ({ title, isActive, onClick, children }: StepperItemProps) => {
    return (
        <li className={'flex flex-col items-center gap-2'}>
            <Button
                type={'button'}
                buttonStyle={isActive ? 'filled' : 'tonal'}
                className={'size-10 p-0'}
                onClick={onClick}>
                {children}
            </Button>

            <div className={'text-sm'}>
                {title}
            </div>
        </li>
    );
};
